module.exports = __webpack_public_path__ + "04_mid_brown.32733212.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/04_mid_brown.png
// module id = J+fu
// module chunks = 0